import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    itemsControllerCreateV1: build.mutation<
      ItemsControllerCreateV1ApiResponse,
      ItemsControllerCreateV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/items`,
        method: 'POST',
        body: queryArg.createBody,
      }),
    }),
    itemsControllerIndexV1: build.query<
      ItemsControllerIndexV1ApiResponse,
      ItemsControllerIndexV1ApiArg
    >({
      query: () => ({ url: `/api/v1/items` }),
    }),
    itemsControllerShowV1: build.query<
      ItemsControllerShowV1ApiResponse,
      ItemsControllerShowV1ApiArg
    >({
      query: (queryArg) => ({ url: `/api/v1/items/${queryArg.id}` }),
    }),
    itemsControllerUpdateV1: build.mutation<
      ItemsControllerUpdateV1ApiResponse,
      ItemsControllerUpdateV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/items/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateBody,
      }),
    }),
    itemsControllerRemoveV1: build.mutation<
      ItemsControllerRemoveV1ApiResponse,
      ItemsControllerRemoveV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/items/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    itemsControllerPublishV1: build.mutation<
      ItemsControllerPublishV1ApiResponse,
      ItemsControllerPublishV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/items/${queryArg.id}/publish`,
        method: 'POST',
      }),
    }),
    itemsControllerUnpublishV1: build.mutation<
      ItemsControllerUnpublishV1ApiResponse,
      ItemsControllerUnpublishV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/items/${queryArg.id}/unpublish`,
        method: 'POST',
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type ItemsControllerCreateV1ApiResponse =
  /** status 200 Returns the created item */ CreateResponse;
export type ItemsControllerCreateV1ApiArg = {
  createBody: ItemCreate;
};
export type ItemsControllerIndexV1ApiResponse =
  /** status 200 Returns the list of items for the current tenant */ IndexResponse;
export type ItemsControllerIndexV1ApiArg = void;
export type ItemsControllerShowV1ApiResponse = /** status 200 Returns item details */ ShowResponse;
export type ItemsControllerShowV1ApiArg = {
  id: number;
};
export type ItemsControllerUpdateV1ApiResponse =
  /** status 200 Returns updated item details */ UpdateResponse;
export type ItemsControllerUpdateV1ApiArg = {
  id: number;
  updateBody: ItemUpdate;
};
export type ItemsControllerRemoveV1ApiResponse =
  /** status 200 Returns deleted item details */ RemoveResponse;
export type ItemsControllerRemoveV1ApiArg = {
  id: number;
};
export type ItemsControllerPublishV1ApiResponse =
  /** status 200 Returns item with published status */ PublishResponse;
export type ItemsControllerPublishV1ApiArg = {
  id: number;
};
export type ItemsControllerUnpublishV1ApiResponse =
  /** status 200 Returns item with unpublished status */ UnpublishResponse;
export type ItemsControllerUnpublishV1ApiArg = {
  id: number;
};
export type CreateResponse = {
  /** Item ID */
  id: number;
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
  /** Cerbos resource context key, e.g. "items:42" */
  contextKey: string;
  /** ID of the tenant this item belongs to */
  tenantId: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
};
export type ItemCreate = {
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
};
export type IndexResponse = {
  /** Item ID */
  id: number;
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
  /** Cerbos resource context key, e.g. "items:42" */
  contextKey: string;
  /** ID of the tenant this item belongs to */
  tenantId: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
}[];
export type ShowResponse = {
  /** Item ID */
  id: number;
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
  /** Cerbos resource context key, e.g. "items:42" */
  contextKey: string;
  /** ID of the tenant this item belongs to */
  tenantId: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
};
export type UpdateResponse = {
  /** Item ID */
  id: number;
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
  /** Cerbos resource context key, e.g. "items:42" */
  contextKey: string;
  /** ID of the tenant this item belongs to */
  tenantId: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
};
export type ItemUpdate = {
  /** Title of the item */
  title?: string;
  /** Content of the item, can be null */
  content?: null | string;
  /** Whether item published or not */
  published?: boolean;
};
export type RemoveResponse = {
  /** Item ID */
  id: number;
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
  /** Cerbos resource context key, e.g. "items:42" */
  contextKey: string;
  /** ID of the tenant this item belongs to */
  tenantId: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
};
export type PublishResponse = {
  /** Item ID */
  id: number;
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
  /** Cerbos resource context key, e.g. "items:42" */
  contextKey: string;
  /** ID of the tenant this item belongs to */
  tenantId: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
};
export type UnpublishResponse = {
  /** Item ID */
  id: number;
  /** Title of the item */
  title: string;
  /** Content of the item, can be null */
  content: null | string;
  /** Whether item published or not */
  published: boolean;
  /** Cerbos resource context key, e.g. "items:42" */
  contextKey: string;
  /** ID of the tenant this item belongs to */
  tenantId: number;
  /** Creation timestamp */
  createdAt: string;
  /** Update timestamp */
  updatedAt: string;
};
